import { createContext } from '@lit/context';

export const fabMenuOpenContext = createContext<boolean>(Symbol('fabMenuOpenContext'));
